const resolveRichText = text => {
  const reg = /[\n\r]/g
  return text.replace(reg, `<br />`)
}

export default resolveRichText
